import { Component, OnInit } from '@angular/core';
import { UserInfo } from '../../models/user-info';
import { BaseComponent } from '../component-base';
import { UsersService } from '../../services/users.service';
import { SelectListItem, SelectListItemValue } from '../../models/select-list-item';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { CrudActions } from '../../models/crud-actions.enum';
import { EmployeeProfileDto, UserDto } from 'src/app/modules/services/users/models/user-management-models';
import { Guid } from 'guid-typescript';
import { UserManagementService } from 'src/app/modules/services/users/services/user.service';
import { AttachmentFileType, AttachmentDto } from '../../common/attachment/attachment';
import { ApiResponse } from '../../models/api-response.model';
import { API_ROUTES } from '../../models/constants/api.routes';
import { Gender } from '../../models/gender.enum';
import { LookupModel } from '../../models/lookup.base.model';
import { AttachementService } from '../../services/attachement';
import { LookupsService } from '../../services/lookups-service';
import { ValidateControls } from '../../validations/ValidateControls';
import * as FileSaver from 'file-saver';
import { CacheService } from '../../services/cashe-service';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.css']
})
export class UserInfoComponent  extends BaseComponent implements OnInit {
  public get CrudActions(): typeof CrudActions {
    return CrudActions;
  }
  id: string | null;
  item: EmployeeProfileDto = null;
  action: CrudActions;
  form: FormGroup;
  isAdd: boolean = true;
  dropdownList = [];
  selectedItems = [];

  startCreateForm: boolean | false;

  constructor(
    private route: ActivatedRoute,
    private userService: UserManagementService,
    private formBuilder: FormBuilder,
    public override router: Router,
    private lookupService: LookupsService,
    public override translate?: TranslateService,
    public attachementService?: AttachementService,

  ) {
    super();
    // this.action = route.snapshot.data.action;
    // route.params.subscribe(res => {
    //   this.id = res['id'];
    // });

    this.id = CacheService.getUserId();
  }

  ngOnInit() {
    this.LoadLaborCardType();
    this.LoadEmployeeType();
    // this.fillRoles();
    this.isAdd = false;
    if (this.id) {
      this.getItem(this.id);
    }
    else {
      this.initForm();
    }
    this.fillBreadCrumb();
  }

  // Get today's date
  today = new Date();
  // Format the date as needed (e.g., YYYY-MM-DD)
  defaultDate = this.today.toISOString().split('T')[0];
  EMAIL_PATTERN: string =
    "^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";


  getItem(id): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.userService.getById(id).subscribe(data => {
        this.item = data.value;
        debugger;
        
        this.GetAttachmentUrl(this.item.photoId);
        this.initForm();
        this.startCreateForm = true;
      });
    });
  }
  public attachmentFileType = AttachmentFileType;
  approval_Attach_List: AttachmentDto[] = [];
  imageSrc: string | ArrayBuffer | null = null;
  public file!: File | null;


  inValidFileExtension: boolean = false;
  sizOrExtensionValidation: boolean = false;
  sizeOfZeroValidation: boolean = false;

  onFileSelected(event: any): void {
    debugger;
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.file = input.files[0];

      // ✅ Store file in FormGroup
      this.form.patchValue({ image: this.file });
      debugger;
      // ✅ Read file as Data URL to display preview
      const reader = new FileReader();
      reader.readAsDataURL(this.file);

      reader.onload = () => {
        debugger;
        this.imageSrc = reader.result; // Set image preview
        debugger;
        let newId = Guid.create();
        let res: AttachmentDto = {
          id: newId.toString(),
          fileName: this.file.name,
          extension: '',
          filePath: '',
          contentType: this.file.type,
          fileContent: reader.result.toString().split(',')[1],
          // fileData: reader.result.toString().split(',')[1],
          thumbnail: "",
          attachmentTypeId: 0,
          size: this.file.size,
          description: ""
        }
        this.form.controls['employeePhoto'].setValue(res);
      };
    }

    ////////////////////////////////


    // this.sizOrExtensionValidation = false;
    // this.sizeOfZeroValidation = false;
    // this.inValidFileExtension = false;
    // let attachments = event.target.files;
    // if (
    //   attachments.length > 0 //&& 
    //   // this.checkAcceptedSize(attachments[0])&& 
    //   // this.checkAcceptedTypes(attachments[0])&& 
    //   // this.checkSizeofzero(attachments[0])
    // )
    //   this.file = attachments[0];

    // else if (!this.checkAcceptedTypes(attachments[0])) {
    //   this.inValidFileExtension = true
    // }

    // else if (!this.checkSizeofzero(attachments[0])) {
    //   this.sizeOfZeroValidation = true
    // }
    // else {
    //   this.resetFile();
    //   this.sizOrExtensionValidation = true;
    // }


    //     this.inValidFileExtension = false;
    //     if (this.file) {
    //       var isAccepted = true;
    //       if (isAccepted) {
    //         const reader = new FileReader();
    //         reader.readAsDataURL(this.file);
    //         reader.onload = () => {
    //           let newId = Guid.create();
    //           let res: AttachmentDto = {
    //             id: newId.toString(),
    //             fileName: this.file.name,
    //             extension: '',
    //             filePath: '',
    //             contentType: this.file.type,
    //             fileContent: reader.result.toString().split(',')[1],
    //             thumbnail: "",
    //             attachmentTypeId: 0,
    //             size: this.file.size,
    //             description: ""
    //           }
    //           this.form.controls['employeePhoto'].setValue(res);
    //         };

    //       }
    //       else {
    //         this.inValidFileExtension = true;
    //       }
    //     }


  }


  downloadAttachment(attachment: AttachmentDto) {
    this.attachementService.get(attachment.id).subscribe((result: any) => {
      debugger;
      if (result) {
          const byteCharacters = atob(result.fileContent);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const file = new Blob([byteArray], { type: result.contentType });
          FileSaver.saveAs(file, result.fileName);
      }
  });
}
GetAttachmentUrl(attachmentId) {
  debugger;
  if(attachmentId !=null && attachmentId != undefined){
    this.attachementService.get(attachmentId).subscribe((result: any) => {
    debugger;
    if (result) {
        const byteCharacters = atob(result.fileContent);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const file = new Blob([byteArray], { type: result.contentType });
        const reader = new FileReader();
        reader.readAsDataURL(file);
  
        reader.onload = () => {
          debugger;
          this.imageSrc = reader.result; // Set image preview
          debugger;
        };
    }
});
  }
  
}
  initForm() {

    if (this.item == null) {
      this.form = this.formBuilder.group({
        id: [{ value: this.id, disabled: true }],
        // userName: [{ value: '', disabled: this.action == CrudActions.View || this.action == CrudActions.Edit }, [Validators.required]],
        email: [{ value: '', disabled: this.action == CrudActions.View || this.action == CrudActions.Edit }, [Validators.required, Validators.maxLength(200), Validators.email, Validators.pattern(this.EMAIL_PATTERN)]],
        phoneNumber: ['' , [Validators.required]],
        fullNameAr:['' , [Validators.required]],
        fullNameEn: ['' , [Validators.required]],
        address: [''],
        password: ['', [Validators.minLength(6) , Validators.required]],
        roleNames: [[]],
        birthDate: [this.defaultDate, [Validators.required]],
        genderId: [0, [Validators.required]],
        nationality: ['', [Validators.required]],
        passportNum: [0, [Validators.required]],//, ValidateControls.IsValidNumber
        passport_ExpiryDate: [this.defaultDate, [Validators.required]],
        passport_IssueDate: [this.defaultDate, [Validators.required]],
        unifiedNumber: ['', [Validators.required, ValidateControls.IsValidNumber]],

        employeeTypeId: [0, [Validators.required]],
        laborCardNumber: [0, [Validators.required, ValidateControls.IsValidNumber]],
        laborCardTypeId: [0, [Validators.required]],
        laborCard_ExpiryDate: [this.defaultDate, [Validators.required]],
        personalNumber: ['', [Validators.required, ValidateControls.IsValidNumber]],

        emiratesIDNum: ['', [Validators.required,Validators.pattern(/^[0-9-]*$/) ]],
        emiratesID_ExpiryDate: [this.defaultDate, [Validators.required]],
        residencyNum: [0, [Validators.required, ValidateControls.IsValidNumber]],
        residency_ExpiryDate: [this.defaultDate, [Validators.required]],
        basicSalary: [0, [Validators.required, ValidateControls.IsValidNumber]],
        totalSalary: [0, [Validators.required, ValidateControls.IsValidNumber]],
        salaryAllowances: [0, [Validators.required, ValidateControls.IsValidNumber]],
        // jobTitle: ['', [Validators.required]],
        // position: ['', [Validators.required]],
        jobStartDate: [this.defaultDate, [Validators.required]],
        unemploymentInsuranceStartDate:[this.defaultDate, [Validators.required]],
        unemploymentInsuranceEndDate:[this.defaultDate, [Validators.required]],
        fines: [0, [Validators.required, ValidateControls.IsValidNumber]],
        employeePhoto: [null],
        image: [null]
      });
    } else {
      this.form = this.formBuilder.group({
        id: [{ value: this.id, disabled: true }],
        // userName: [{ value: this.item?.user?.userName ?? '', disabled: this.action == CrudActions.View || this.action == CrudActions.Edit }, [Validators.required]],
        email: [{ value: this.item?.email, disabled: this.action == CrudActions.View || this.action == CrudActions.Edit }, [Validators.required, Validators.maxLength(200), Validators.email, Validators.pattern(this.EMAIL_PATTERN)]],
        phoneNumber: [this.item?.user?.phoneNumber],
        fullNameAr:[this.item?.fullNameAr],
        fullNameEn: [this.item?.fullNameEn],
        address: [this.item?.address],
        password: ['', [Validators.minLength(6)]],
        roleNames: [this.item?.user?.roleNames ?? []],
        birthDate: [this.item.birthDate.split('T')[0], [Validators.required]],
        genderId: [this.item.genderId, [Validators.required]],
        nationality: [this.item.nationality, [Validators.required]],
        passportNum: [this.item.passportNum, [Validators.required]],
        passport_ExpiryDate: [this.item.passport_ExpiryDate.split('T')[0], [Validators.required]],
        passport_IssueDate: [this.item.passport_IssueDate.split('T')[0], [Validators.required]],
        unifiedNumber: [this.item.unifiedNumber, [Validators.required]],

        employeeTypeId: [this.item.employeeTypeId, [Validators.required]],
        laborCardNumber: [this.item.laborCardNumber, [Validators.required]],
        laborCardTypeId: [this.item.laborCardTypeId, [Validators.required]],
        laborCard_ExpiryDate: [this.item.laborCard_ExpiryDate.split('T')[0], [Validators.required]],
        personalNumber: [this.item.personalNumber, [Validators.required]],

        emiratesIDNum: [this.item.emiratesIDNum, [Validators.required,Validators.pattern(/^[0-9-]*$/) ]],
        emiratesID_ExpiryDate: [this.item.emiratesID_ExpiryDate.split('T')[0], [Validators.required]],
        residencyNum: [this.item.residencyNum, [Validators.required]],
        residency_ExpiryDate: [this.item.residency_ExpiryDate.split('T')[0], [Validators.required]],
        basicSalary: [this.item.basicSalary, [Validators.required, ValidateControls.IsValidNumber]],
        totalSalary: [this.item.totalSalary, [Validators.required, ValidateControls.IsValidNumber]],
        salaryAllowances: [this.item.salaryAllowances, [Validators.required, ValidateControls.IsValidNumber]],
        // jobTitle: [this.item.jobTitle, [Validators.required]],
        // position: [this.item.position, [Validators.required]],
        jobStartDate: [this.item.jobStartDate.split('T')[0], [Validators.required]],
        unemploymentInsuranceStartDate:[this.item.unemploymentInsuranceStartDate.split('T')[0], [Validators.required]],
        unemploymentInsuranceEndDate:[this.item.unemploymentInsuranceEndDate.split('T')[0], [Validators.required]],
        fines: [this.item.fines, [Validators.required]],
        employeePhoto: [null],
        image: [null]
      });
    }

    if (this.action == CrudActions.View) {
      this.form.disable();
    }
    this.startCreateForm = true;
  }
  genders = Object.values(Gender).filter(value => typeof value === 'number') as number[]; // Get integer values from enum
  //selectedGender: Gender | undefined;

  formSubmitted: boolean = false;

  onAddImage(): void {
    alert('Add Image Clicked! You can implement a custom action here.');
  }
  submitForm(form) {
    debugger;
    if (form.status == 'VALID') {
      this.confirm("shared.save").then((result) => {
        if (!result.isConfirmed) return;
        if (this.action == CrudActions.Create) {
          this.create();
        }
        else if (this.action == CrudActions.Edit) {
          this.update();
        }
      });
    } else {
      this.formSubmitted = true;
    }
  }
  update() {
    debugger;
    this.item = this.form.value;

    const jsonString = JSON.stringify(this.form.value);
    console.log(jsonString);

    var roleNames = new Array<string>();
    this.form.value.roleNames.forEach(element => {
      roleNames.push(element.id);
    });
    this.form.controls['roleNames'].setValue(roleNames);
    this.userService.updateUser(this.id, this.item)
      .subscribe((data: ApiResponse<UserDto>) => {
        debugger;
        if (!data) {
          return;
        }
        if (data.value != null) {
          this.router.navigate(['services', 'users']);
          this.done('shared.doneSuccessfully');
        }
        else {
          this.failed(data.message);
        }
      });
  }
  create() {
    this.item = this.form.value;

    const jsonString = JSON.stringify(this.form.value);
    console.log(jsonString);

    var roleNames = new Array<string>();
    this.form.value.roleNames.forEach(element => {
      roleNames.push(element.id);
    });
    this.form.controls['roleNames'].setValue(roleNames);
    this.userService.saveUser(this.form.value).subscribe((data: ApiResponse<UserDto>) => {
      if (!data) {
        return;
      }
      if (data.value != null && data.value.id != null) {
        this.router.navigate(['services', 'users']);
        this.done('shared.doneSuccessfully');
      }
      else {
        this.failed(data.message);
      }
    });
  }


  private fillBreadCrumb() {
    this.breadcrumbItems = [
      { label: 'LicenseSystem.employees', url: '/services/users' },
      { label: 'common.profile', url: '/get-user-info' }
    ];
  }
  onSearch() {
    return new Promise<void>((resolve, reject) => {
    }).then(() => this.initForm());
  }
  laborCardTypes!: LookupModel[];
  employeeTypes!: LookupModel[];

  LoadLaborCardType() {
    this.lookupService
      .getLaborCardTypes()
      .subscribe((data: ApiResponse<LookupModel[]>) => {
        this.laborCardTypes = data.value;
      });
  }
  LoadEmployeeType() {
    this.lookupService
      .getEmployeeTypes()
      .subscribe((data: ApiResponse<LookupModel[]>) => {
        this.employeeTypes = data.value;
      });
  }
  roleRoute: string = API_ROUTES.Lookups.Roles;

  // fillRoles() {
  //   this.lookupService
  //     .getAllRoles(2).subscribe((data: any) => {
  //       if (!data.value) {
  //         return;
  //       }
  //       this.dropdownList = data.value.map((r) => {
  //         return {
  //           value: r.id as number,
  //           text: this.isArabic ? r.nameAr : r.nameEn,
  //         }
  //       });
  //       this.form.controls['roleNames'].setValue(this.dropdownList)
  //     });
  // }
  onItemSelect(item: any) {
  }
  onSelectAll(items: any) {
  }
}


